module.exports = __webpack_public_path__ + "static/img/new_active.0a11ed6d.svg";